import { Grid, makeStyles } from '@material-ui/core';
import { TextLabel } from 'commons/Label/TextLabel';
import React from 'react';
import { AutoCompleteWithValue } from './AutoCompleteWithValue';

const useStyles = makeStyles(() => ({
  generalContainer: {
    height: '70px'
  }
}));

export const AutoCompleteWithLabel = ({
  label, getOptionLabel, isTranslatingOptions, value, options, required, isLoading, onChange, enableColorChangeOnModification,
  startsModified = false, className, valueName, isFree, isMultiple, textFieldLabel
}) => {
  const classes = useStyles();

  return (
    <Grid item>
      <Grid alignItems='center' className={classes.generalContainer} container justifyContent='space-between' spacing={2} wrap='nowrap'>
        <Grid item xs={6}>
          <TextLabel required={required} text={label}/>
        </Grid>
        <Grid item xs={6}>
          <AutoCompleteWithValue
            className={className}
            enableColorChangeOnModification={enableColorChangeOnModification}
            getOptionLabel={getOptionLabel}
            isFree={isFree}
            isLoading={isLoading}
            isMultiple={isMultiple}
            isTranslatingOptions={isTranslatingOptions}
            label={textFieldLabel}
            onChange={value => onChange(value)}
            options={options}
            required={required}
            startsModified={startsModified}
            value={value}
            valueName={valueName}
            variant='outlined'
          />
        </Grid>
      </Grid>
    </Grid>
  )
};